import axios from "axios";
import qs from 'qs';
import { Toast } from 'mint-ui';
//设置默认超时
axios.defaults.timeout = 50000;
//设置默认请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 根据 process.env.NODE_ENV 的值判断当前是什么环境  在config里面配置api跨域
//const host = process.env.NODE_ENV === 'development' ? '/api/' : 'http://app.zhuangneizhu.com' 

const host = 'http://app.zhuangneizhu.com';
axios.defaults.baseURL = host //请求网址

// 请求拦截器
axios.interceptors.request.use(config => {
    return config;
}, err => {
    Toast({
        message: '请求超时!',
        duration: 1000,
    })
    return Promise.resolve(err);
})

// 响应拦截器
axios.interceptors.response.use(data => {
    if (data.status && data.status == 200 && data.data.status == 'error') {
        Toast({
            message: data.data.msg,
            duration: 1000,
        })
        return;
    }
    return data;
}, err => {
    if (err.response.status == 504 || err.response.status == 404) {
        Toast({
            message: '服务器被吃了⊙﹏⊙∥',
            duration: 1000,
        })
    } else if (err.response.status == 403) {
        Toast({
            message: '权限不足,请联系管理员!',
            duration: 1000,
        })

    } else {
        Toast({
            message: '未知错误!',
            duration: 1000,
        })
    }
    return Promise.resolve(err);
})

export const Get = async (params, url) => {
    let param = params || {}
    let res = await axios({
        method: 'get',
        url: url,
        params: param,
    });
    return res;
};

export const Post = async (data, url) => {
    let datas = data || '{}';
    let res = await axios({
        method: 'post',
        url: url,
        data: qs.stringify(datas),
    });
    return res;
};

export const JsonPost = async (data, url) => {
    let datas = data || '{}';
    let res = await axios({
        method: 'post',
        header: {
            'content-type': 'application/json'
        },
        url: url,
        data: JSON.stringify(datas),
    });
    return res;
};

// export const uploadFileRequest = (data, url) => {
//     let datas = data || '{}';
//     let res = await axios({
//         method: 'post',
//         header: {
//             'content-type': 'multipart/form-data'
//         },
//         url: url,
//         data: JSON.stringify(datas),
//     });
//     return res;
//   }


// WEBPACK FOOTER //
// ./src/api/http.js